import { FavoritesButton } from '@/app/elements/favorites-button/favorites-button';
import BadgeFactory from '@/app/components/badge/badge-factory';
import BadgeFactoryClient from '@/app/components/badge/badge-factory.client';
import type { BadgeType } from '@/types/badges';

import './styles/@theme';
import { GameLabel } from '@/types/games';
import { SwjJackpotTicker } from '@/app/components/site-wide-jackpot/subcomponents/jackpot-ticker';

type GameDetailsSectionProps = {
    gameName: string;
    gameBetInfo: string;
    hasJackpotValue: boolean;
    uid: string;
    label?: string;
    isSWJAvailable: boolean;
    feedsCode?: string;
};

export const GameDetailsSection = ({
    gameName,
    gameBetInfo,
    uid,
    label,
    isSWJAvailable,
    feedsCode
}: GameDetailsSectionProps) => {
    const badgeType = label !== GameLabel.New && (label as BadgeType);
    return (
        <div className="game-tile__details-section game-description__casino-explore">
            <div className="game-description">
                {badgeType && <BadgeFactory badgeType={badgeType} />}
                <p className="game-title game-title__casino-explore">{gameName}</p>
                {gameBetInfo && <p className="min-max-bet">{gameBetInfo}</p>}
            </div>
            {isSWJAvailable ? (
                <SwjJackpotTicker />
            ) : (
                feedsCode && <BadgeFactoryClient feedsCode={feedsCode}>{null}</BadgeFactoryClient>
            )}
            <div className="favourite-component">
                <FavoritesButton uid={uid} />
            </div>
        </div>
    );
};
